import { render, staticRenderFns } from "./BedEdit.vue?vue&type=template&id=0c1a81a5&"
import script from "./BedEdit.vue?vue&type=script&lang=js&"
export * from "./BedEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports